<div class="page-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Guardrail Library › Business Guardrails"
      pageSubtitle="Track latency, cost, behaviors side by side."
    ></app-navbar>

    <div class="content">
      <app-pending-reviews-banner></app-pending-reviews-banner>
      <!-- Stats Row -->
     <div class="stats-row">
  <div class="stat-card" *ngFor="let s of stats()">
    <div class="stat-icon" [style.background]="s.iconBg">
      <svg *ngIf="s.icon === 'shield'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      <svg *ngIf="s.icon === 'shield-check'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
      <svg *ngIf="s.icon === 'shield-alert'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="7.5" x2="12" y2="12.75"/><circle cx="12" cy="16" r="1.1" stroke="none" [attr.fill]="s.iconColor"/></svg>
      <svg *ngIf="s.icon === 'clock'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <svg *ngIf="s.icon === 'check'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>
      <svg *ngIf="s.icon === 'lock'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
      <svg *ngIf="s.icon === 'alert'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg>
      <svg *ngIf="s.icon === 'percent'" width="26" height="26" viewBox="0 0 24 24" fill="none" [attr.stroke]="s.iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
    </div>
    <div class="stat-text-col">
      <span class="stat-label">{{ s.label }}</span>
      <span class="stat-value">{{ s.value }}</span>
      <span class="stat-delta" [class.warning]="s.isWarning">{{ s.delta }}</span>
    </div>
  </div>
</div>
      <div class="body-row">
        <!-- Left: Guardrail Library -->
        <div class="library-card">
          <div class="library-header">
            <h3 class="library-title">Guardrail Library</h3>
          </div>

          <div class="tabs-actions-row">
            <div class="tabs-row">
              <button
                class="tab-btn"
                *ngFor="let tab of filterTabs"
                [class.active]="activeFilter() === tab"
                (click)="setActiveFilter(tab)"
              >{{ tabLabel(tab) }}</button>
            </div>
            <div class="bulk-actions">
              <button
                class="decline-btn"
                [disabled]="!declinableIds().length || isApproving() || isDeclining()"
                (click)="declineSelected()"
              >{{ isDeclining() ? 'Declining…' : 'Decline' }}</button>
              <button
                class="approve-btn"
                [disabled]="!approvableIds().length || isApproving() || isDeclining()"
                (click)="approveSelected()"
              >{{ isApproving() ? 'Approving…' : 'Approve' }}</button>
            </div>
          </div>

          <div class="category-filter-row">
            <ng-container *ngIf="documentOptions().length > 0">
              <span class="category-filter-label">Document:</span>
              <select
                class="document-select"
                aria-label="Filter by document"
                (change)="setDocumentFilter($any($event.target).value)"
              >
                <option value="All" [selected]="activeDocumentFilter() === 'All'">All documents</option>
                <option
                  *ngFor="let d of documentOptions()"
                  [value]="d.id"
                  [selected]="activeDocumentFilter() === d.id"
                >{{ d.name }} ({{ d.count }})</option>
              </select>
            </ng-container>
            <button
              type="button"
              class="category-chip dup-filter-chip"
              [class.active]="duplicatesOnly()"
              [disabled]="duplicateGroupCount() === 0 && !duplicatesOnly()"
              title="Show only policies that have similar versions"
              (click)="toggleDuplicatesOnly()"
            >Duplicates ({{ duplicateGroupCount() }})</button>
            <label class="page-size-control top-page-size">
              <span>Rows per page</span>
              <select class="page-size-select" (change)="onPageSizeSelect($any($event.target).value)">
                <option
                  *ngFor="let n of pageSizeOptions"
                  [value]="n"
                  [selected]="!showCustomPageSize() && pageSize() === n"
                >{{ n }}</option>
                <option value="custom" [selected]="showCustomPageSize()">Custom</option>
              </select>
              <input
                *ngIf="showCustomPageSize()"
                #customSize
                class="page-size-input"
                type="number"
                min="1"
                [max]="maxPageSize"
                [value]="pageSize()"
                aria-label="Custom rows per page"
                (change)="onPageSizeTyped(customSize)"
                (keydown.enter)="onPageSizeTyped(customSize)"
              />
            </label>
          </div>

          <div class="category-filter-row" *ngIf="categoryOptions().length > 1">
            <span class="category-filter-label">Category:</span>
            <div class="category-chips">
              <button
                class="category-chip"
                *ngFor="let cat of categoryOptions()"
                [class.active]="activeCategoryFilter() === cat"
                (click)="setCategoryFilter(cat)"
              >{{ formatCategory(cat) }}</button>
            </div>
          </div>

          <!-- Selection bar: the header checkbox selects every guardrail the filters match, on all pages -->
          <div class="selection-bar" *ngIf="selectedCount() > 0">
            <span *ngIf="allFilteredSelected()">
              All {{ filteredRules().length }} guardrail{{ filteredRules().length === 1 ? '' : 's' }} selected, across all pages.
            </span>
            <span *ngIf="!allFilteredSelected()">{{ selectedCount() }} selected.</span>
            <button type="button" class="link-btn" (click)="clearSelection()">Clear selection</button>
          </div>

          <div class="table-wrap">
            <table class="rules-table">
              <thead>
                <tr>
                  <th class="col-check">
                    <div
                      class="row-check header-check"
                      [class.checked]="allFilteredSelected()"
                      [class.partial]="someFilteredSelected()"
                      [title]="allFilteredSelected() ? 'Deselect all ' + filteredRules().length : 'Select all ' + filteredRules().length"
                      (click)="toggleSelectAll($event)"
                    >
                      <svg *ngIf="allFilteredSelected()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                      <svg *ngIf="someFilteredSelected()" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    </div>
                  </th>
                  <th>Policy</th>
                  <th>Category</th>
                  <th>Conf.</th>
                  <th class="col-status">Status</th>
                  <th>Reviewed By</th>
                  <th>Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of pagedRules()" [class.selected-row]="isViewed(r.id)" (click)="viewDetail(r.id)">
                  <td class="col-check" (click)="toggleSelect(r.id, $event)">
                    <div class="row-check" [class.checked]="isSelected(r.id)">
                      <svg *ngIf="isSelected(r.id)" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                  </td>
                  <td class="rule-name-cell" [title]="r.ruleName">
                    <div class="rule-name-main">
                      {{ r.ruleName }}
                      <span
                        *ngIf="r.duplicateCount > 1"
                        class="dup-badge"
                        [title]="r.duplicateCount + ' semantically similar extractions — click row to review duplicates'"
                      >{{ r.duplicateCount }}</span>
                    </div>
                    <div class="rule-name-sub" *ngIf="r.classification">{{ r.classification }}</div>
                    <div class="rule-name-sub rule-name-doc" *ngIf="r.documentName && !r.classification">{{ r.documentName }}</div>
                  </td>
                  <td class="category-cell" [title]="formatCategory(r.category)"><span class="pill" [ngClass]="'pill-' + r.categoryColor">{{ formatCategory(r.category) }}</span></td>
                  <td class="confidence-cell">{{ getConfidencePercent(r.confidence) }}%</td>
                  <td class="col-status" [title]="displayStatus(r.status)">
                    <span
                      class="status-dot"
                      [class.active]="displayStatus(r.status) === 'Approved'"
                      [class.pending]="displayStatus(r.status) === 'Needs Review'"
                      [class.declined]="displayStatus(r.status) === 'Declined'"
                    ></span>
                    {{ displayStatus(r.status) }}
                  </td>
                  <td class="owner-cell" [title]="r.owner">{{ r.owner }}</td>
                  <td class="date-cell" [title]="r.lastUpdated">{{ r.lastUpdated }}</td>
                </tr>
                <tr class="empty-row" *ngIf="!isLoadingRules() && filteredRules().length === 0">
                  <td class="empty-table-cell" colspan="7">
                    <div class="empty-table-message">No guardrails available.</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-row">
            <span class="page-range">{{ rangeStart() }}–{{ rangeEnd() }} of {{ filteredRules().length }}</span>

            <div class="page-buttons">
              <button class="page-arrow" [disabled]="currentPage() === 1" (click)="prevPage()">‹</button>

              <ng-container *ngFor="let p of pageNumbers()">
                <button
                  *ngIf="p !== '...'"
                  class="page-num"
                  [class.active]="p === currentPage()"
                  (click)="goToPage(p)"
                >{{ p }}</button>
                <span *ngIf="p === '...'" class="page-dots">...</span>
              </ng-container>

              <button class="page-arrow" [disabled]="currentPage() === totalPages()" (click)="nextPage()">›</button>
            </div>
          </div>

        </div>

        <!-- Right: Detail panel -->
        <div class="right-column" *ngIf="viewedGuardrail() as g">
          <div class="detail-card">
            <div class="detail-header">
              <div class="detail-header-left">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0D1121" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <h3 class="detail-title">{{ g.policyName || g.normalizedStatement || g.condition }}</h3>
              </div>
              <div class="detail-actions">
                <app-button
                  variant="primary"
                  size="sm"
                  [disabled]="isApproving() || isDeclining() || isApproved(g.status)"
                  (clicked)="approveGuardrail(g.id)"
                >{{ isApproving() ? 'Approving…' : (isApproved(g.status) ? 'Approved' : 'Approve') }}</app-button>
                <app-button
                  variant="secondary"
                  size="sm"
                  [disabled]="isApproving() || isDeclining() || isDeclined(g.status) || isApproved(g.status)"
                  (clicked)="declineGuardrail(g.id)"
                >{{ isDeclining() ? 'Declining…' : (isDeclined(g.status) ? 'Declined' : 'Decline') }}</app-button>
                <button class="close-x" (click)="closeDetail()">✕</button>
              </div>
            </div>

            <!-- Duplicates submenu: shown only when this guardrail belongs to a group -->
            <div class="dup-submenu" *ngIf="viewedDuplicates().length > 1">
              <div class="dup-submenu-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {{ viewedDuplicates().length }} semantically similar versions — each one is approved or declined on its own
              </div>
              <div class="dup-submenu-tabs">
                <button
                  class="dup-tab"
                  *ngFor="let d of viewedDuplicates(); let i = index"
                  [class.active]="isSelectedDuplicate(d.id)"
                  (click)="selectDuplicate(d.id)"
                  [title]="d.policyName || d.normalizedStatement || ''"
                >
                  <span class="dup-tab-num">{{ i + 1 }}</span>
                  <span class="dup-tab-label">{{ d.policyName || ('Version ' + (i + 1)) }}</span>
                  <span class="dup-tab-conf">{{ getConfidencePercent(d.confidence) }}%</span>
                  <span
                    class="dup-tab-status"
                    [class.approved]="isApproved(d.status)"
                    [class.declined]="isDeclined(d.status)"
                  ></span>
                </button>
              </div>
            </div>

            <div class="detail-body">
              <div class="detail-row" *ngIf="g.policyName">
                <span class="section-label">Policy Name</span>
                <span class="section-value">{{ g.policyName }}</span>
              </div>

              <div class="detail-row">
                <span class="section-label">Document</span>
                <span class="section-value doc-name-value">{{ g.documentName || '—' }}</span>
              </div>

              <div class="detail-row">
                <span class="section-label">Category</span>
                <span class="section-value"><span class="pill" [ngClass]="'pill-' + categoryColor(g.ruleType)">{{ formatCategory(g.ruleType) }}</span></span>
              </div>

              <div class="detail-row" *ngIf="g.classification">
                <span class="section-label">Classification</span>
                <span class="section-value">{{ g.classification }}</span>
              </div>

              <div class="detail-row align-top" *ngIf="g.normalizedStatement">
                <span class="section-label">Policy</span>
                <span class="section-value source-text-value">{{ g.normalizedStatement }}</span>
              </div>

              <div class="detail-row align-top">
                <span class="section-label">Source Text</span>
                <span class="section-value source-text-value">{{ g.sourceClause || '—' }}</span>
              </div>

              <div class="detail-row">
                <span class="section-label">Status</span>
                <span class="section-value">{{ displayStatus(g.status) || '—' }}</span>
              </div>

              <div class="detail-row align-top">
                <span class="section-label">Confidence</span>
                <div class="confidence-wrap">
                  <div class="confidence-track">
                    <div class="confidence-fill" [style.width.%]="getConfidencePercent(g.confidence)"></div>
                  </div>
                  <span class="section-value confidence-value">{{ getConfidencePercent(g.confidence) }}%</span>
                </div>
              </div>

              <div class="detail-row">
                <span class="section-label">Added</span>
                <span class="section-value">{{ formatDateTime(g.createdAt) }}</span>
              </div>

              <ng-container *ngIf="isReviewed(g.status)">
                <div class="detail-row">
                  <span class="section-label">Reviewed By</span>
                  <span class="section-value">{{ g.reviewedBy || '—' }}</span>
                </div>

                <div class="detail-row">
                  <span class="section-label">Reviewed At</span>
                  <span class="section-value">{{ formatDateTime(g.reviewedAt) }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>